import { Button, Col, Typography } from "antd";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Loader from "../controls/Loader";
import { confirmEmail } from "../repository/auth.repository";
import { useGuard } from "../Guard";

export function ConfirmEmailPage() {
  const guard = useGuard();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const params = Object.fromEntries(searchParams.entries());

  const [loading, setLoading] = useState(true);
  const [ok, setOk] = useState(false);
  const [seconds, setSeconds] = useState(3);

  // Lifecycle

  useEffect(() => {
    guard.signOut();

    if (params.code && params.userUid) {
      confirmEmail({
        userUid: params.userUid,
        code: params.code,
      })
        .then(() => {
          setOk(true);
          setLoading(false);
        })
        .catch(() => {
          setOk(false);
          setLoading(false);
        });
    } else {
      setOk(false);
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    let i: any;
    if (ok) {
      i = setInterval(() => {
        if (seconds < 1) {
          clearInterval(i);
          navigate("/login", {
            replace: true,
          });
        } else {
          setSeconds((seconds) => seconds - 1);
        }
      }, 1000);
    }

    return () => {
      clearInterval(i);
    };
  }, [ok, seconds]);

  // Events

  function onSignIn(): void {
    navigate("/login", {
      replace: true,
    });
  }

  return (
    <Col className="flex flex-1 flex-col items-center justify-center">
      {loading && (
        <>
          <Typography.Text
            className="max-w-96 p-4 text-center"
            type="secondary"
          >
            Confirming email..
          </Typography.Text>
          <Loader />
        </>
      )}
      {!loading && ok && (
        <>
          <Typography.Text className="max-w-96 p-4 text-center" type="success">
            Email successfully confirmed. You will be redirect to login page.
            You will redirect in {seconds}..
          </Typography.Text>
          <Button onClick={onSignIn}>Sign In</Button>
        </>
      )}
      {!loading && !ok && (
        <>
          <Typography.Text className="max-w-96 p-4 text-center" type="danger">
            Something went wrong, request new reset password link and try again.
          </Typography.Text>
          <Button onClick={onSignIn}>Sign In</Button>
        </>
      )}
    </Col>
  );
}

export default ConfirmEmailPage;
